enum ExecutionStatus {
  NOT_GIVEN = 10,
  REQUESTED_DIAGNOSIS = 15,
  REQUESTED_EXECUTION = 16,
  EXECUTE_DIAGNOSIS = 20,
  EXECUTE = 21,
  DO_NOT_DIAGNOSE = 98,
  DO_NOT_EXECUTE = 99,
}

export default ExecutionStatus;